export default __webpack_public_path__ + "favicon-192x192.v2.png";